/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { NAV_TYPE_TOP } from "constants/ThemeConstant";
import utils from "utils";
import MenuContent from "./MenuContent";
import { Button, Form, Input, Modal, message, Grid } from "antd";
import axios from "axios";
import { env } from "configs/EnvironmentConfig";
import logo from "assets/images/log.svg";
import ApiConfig from "configs/ApiConfig";

export const TopNav = ({ topNavColor }) => {
  const props = { topNavColor };
  const { useBreakpoint } = Grid;

  const [openSupportModal, setOpenSupportModal] = useState(false);
  const [form] = Form.useForm();
  const onSubmit = async (values) => {
    const submitIssue = await axios.post(
      `${env?.API_ENDPOINT_URL}/settings/customer-register-mail`,
      { ...values }
    );
    console.log(submitIssue);
    message.success("Our Team will contact you");
    setOpenSupportModal(false);
    form.resetFields();
  };
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = screens.length === 0 ? false : !screens.includes("lg");

  const [settings, setsettings] = useState({});
  const getaccountsettings = async () => {
    try {
      const response = await axios.get(
        `${env?.API_ENDPOINT_URL}/${ApiConfig.website.getaccountsettings}`
      );
      setsettings({ ...response?.data?.[0] });
      // form.setFieldsValue({homepage:response?.data?.[0]?.homepage,
      //   home:response?.data?.[0]?.hiddenmenu?.includes("/home"),
      //   rule:response?.data?.[0]?.hiddenmenu?.includes("/rule"),
      //   portal:response?.data?.[0]?.portal,
      //   rulelink:response?.data?.[0]?.rule
      // })
    } catch (error) {
      return [];
    }
  };
  useEffect(() => {
    getaccountsettings();
  }, []);
  return (
    <div
      className={`top-nav ${utils.getColorContrast(topNavColor)}`}
      style={{ backgroundColor: topNavColor }}
    >
      <Modal
        open={openSupportModal}
        onCancel={() => setOpenSupportModal(false)}
        okText="Submit"
        title="New Registration"
        maskClosable={false}
        footer={null}
      >
        <Form
          form={form}
          onFinish={onSubmit}
          wrapperCol={{
            span: 18,
          }}
          labelCol={{
            span: 6,
          }}
          labelAlign="left"
          onS
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[
              {
                required: true,
                message: "Please input your name",
              },
            ]}
          >
            <Input placeholder="Name" />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                required: true,
                message: "Please input your Email",
              },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="phone"
            label="Phone"
            rules={[
              {
                required: true,
                message: "Please input your Phone",
              },
            ]}
          >
            <Input placeholder="Phone" />
          </Form.Item>
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
          >
            <Button onClick={() => setOpenSupportModal(false)}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </Form>
      </Modal>
      <div
        className="top-nav-wrapper"
        style={isMobile ? { marginBottom: "-30px" } : {}}
      >
        {process.env.REACT_APP_DEV_API_REDIRECT_URL.includes("tcbl") &&
        isMobile ? (
          <div
            style={{
              color: "#fff",
              width: "100%",
              backgroundColor: "black",
              transform: "translate(0px,0px)",
              zIndex: "999",
              position: "absolute",
            }}
          >
            <img
              src={
                (settings?.logo) //|| "https://tcbl2.poindexters.ca/img/loc.jpg"
              }
              alt=""
              style={{ marginTop: "5px", backgroundColor: "#000" }}
              width="20px"
            />
            {process.env.REACT_APP_DEV_API_REDIRECT_URL.includes("tcbl") && (
              <span
                style={{
                  backgroundColor: "black",
                  marginRight: "35px",
                  marginTop: "5px",
                  color: "white",
                  borderRadius: "2px",
                  border: "2px solid white",
                  fontSize: "12px",
                  padding: "0px 10px",
                  fontWeight: "700",
                  transform: "skew(-10deg)",
                  float: "right",
                }}
              >
                <a
                  href={`https://${settings?.portal}`}
                  target="_blank"
                  style={{ color: "#fff" }}
                  rel="noreferrer"
                >
                  Login / Signup
                </a>
              </span>
            )}
            {/* {process.env.REACT_APP_DEV_API_REDIRECT_URL.includes("tcbl") && (
              <span
                onClick={() => setOpenSupportModal(true)}
                style={{
                  backgroundColor: "black",
                  marginRight: "5px",
                  marginTop: "5px",
                  padding: "0px 3px",
                  color: "white",
                  borderRadius: "2px",
                  border: "2px solid white",
                  fontSize: "12px",
                  fontWeight: "700",
                  transform: "skew(-10deg)",
                  float: "right",
                }}
              >
                Register New Team
              </span>
            )} */}
          </div>
        ) : null}
        <MenuContent type={NAV_TYPE_TOP} {...props} />
      </div>
    </div>
  );
};

const mapStateToProps = ({ theme }) => {
  const { topNavColor } = theme;
  return { topNavColor };
};

export default connect(mapStateToProps)(TopNav);
